import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroupContext } from './RadioGroupContext';
import { cn } from 'Utils/cn';

const RadioGroup = React.forwardRef(function RadioGroup(props, ref) {
    const { children, direction = 'row', className, name, value, onChange, defaultValue } = props;

    return (
        <>
            <div
                ref={ref}
                className={cn(
                    'flex flex-wrap gap-y-3 gap-x-6',
                    direction === 'column' && 'flex-col items-start',
                    className,
                )}
            >
                <RadioGroupContext.Provider value={{ value, defaultValue, onChange, name }}>
                    {children}
                </RadioGroupContext.Provider>
            </div>
        </>
    );
});

RadioGroup.propTypes = {
    children: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    defaultValue: PropTypes.string,
    direction: PropTypes.oneOf(['row', 'column']),
};

export default RadioGroup;
